import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';
import { activate, optimizelyUserId, optimizelyUserContext } from '../optimizely';
import railsAxios from '../railsAxios';
import redirectTo from './redirectTo';

export default async function beforeEnterReg2(to, from, next) {
  try {
    const completed = await store.dispatch('registration/checkReg1Completed');
    if (completed === 'redirect') {
      return;
    }
    let optlyVariation = '';
    const userContext = await optimizelyUserContext();
    const attributes = {
      customer_type: userContext.customer_type,
    };
    if (localStorage.getItem('show-pre-reg2-ebs') === 'true') {
      // if selected via peteshow
      localStorage.removeItem('show-pre-reg2-ebs');
      optlyVariation = 'ebs';
      localStorage.setItem('optlyVariation', 'ebs');
    } else {
      optlyVariation = activate('control_or_ebs', optimizelyUserId(), attributes);
    }
    if (optlyVariation === 'ebs') {
      const accountID = await store.get('account').account_id;
      const response = await railsAxios.post(`/api/ebs_pre_reg2/show/${accountID}`, {});
      if (response === null) {
        store.dispatch('setBackendErrorMessage', 'no response body from simplic gateway for ebs pre reg2 experiment');
        redirectTo('/account_home', '/v/registrar');
      } else if (response.data.error) {
        store.dispatch('setBackendErrorMessage', response.errors);
        redirectTo('/account_home', '/v/registrar');
      } else if (response.status !== 200 && response.status !== 201) {
        store.dispatch('setBackendErrorMessage', `unexpected status returned from simplic gateway for ebs pre reg2 experiment: ${response.status}`);
        redirectTo('/account_home', '/v/registrar');
      } else if (response.data.serasa_prefilter_rules_result === 'simplic_hen1_prefilter_decline') {
        redirectTo('/contract/decline', '/v/registrar');
      } else if (response.data.ebs_decision === 'ebs_optional' || response.data.ebs_decision === 'ebs_required') {
        redirectTo('/v/pessoal/ebs', '/v/registrar');
      }
    }

    next();
  } catch (e) {
    store.dispatch('setBackendErrorMessage');
    captureRenderBlockingException(e);
  }
}
